<div class="tab-content-wrapper">
  <p *ngIf="matchedConnectors.length === 0">
    Could not find any connectors of {{ type }} type.
  </p>
  <div *ngIf="existingConnectors.length > 0">
    Existing configured connector(s) for this type:
    <mat-card
      class="existing-connector-wrapper"
      *ngFor="let connector of existingConnectors"
    >
      <span class="tag">{{ connector.tag }}</span>
      <div class="actions">
        <button
          mat-icon-button
          (click)="openEditConnectorDialogForm(connector)"
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="openConfirmDeleteConfiguredConnectorDialog(connector)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </mat-card>
  </div>
  <form
    *ngIf="matchedConnectors.length > 0 && existingConnectors.length === 0"
    [formGroup]="selectConnectorForm"
  >
    <h4>
      Currently no configured connector for {{ type }} type. Add one below.
    </h4>
    <mat-form-field appearance="fill">
      <mat-label>Connector</mat-label>
      <mat-select formControlName="selectedConnector">
        <mat-option
          *ngFor="let connector of matchedConnectors"
          [value]="connector"
        >
          {{ connector.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <br />
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="openAddConnectorDialogForm()"
    >
      Add connector
    </button>
  </form>
</div>
